export enum ActivityCompletion {
  Positivo = 'Positivo',
  Negativo = 'Negativo',
  NonNecessario = 'Non Necessario',
  RichiestaModifiche = 'Richiesta Modifiche',
  Firma = 'Firma'
}
